import { render } from "./HowWeWorks.vue?vue&type=template&id=5d293597"
import script from "./HowWeWorks.vue?vue&type=script&lang=js"
export * from "./HowWeWorks.vue?vue&type=script&lang=js"

import "./HowWeWorks.vue?vue&type=style&index=0&id=5d293597&lang=scss"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__